import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import PublicLayout from '@/components/layout/PublicLayout';
import AthleteLayout from '@/components/layout/AthleteLayout';
import ProtectedAthleteRoute from '@/components/ProtectedAthleteRoute';
import HomePage from '@/pages/HomePage';
import AnnouncementsPage from '@/pages/AnnouncementsPage';
import AnnouncementDetailPage from '@/pages/AnnouncementDetailPage';
import CompetitionsPage from '@/pages/CompetitionsPage';
import CompetitionDetailPage from '@/pages/CompetitionDetailPage';
import LiveScoresPage from '@/pages/LiveScoresPage';
import CompetitionScorePage from '@/pages/CompetitionScorePage';
import SchedulePage from '@/pages/SchedulePage';
import VenuesPage from '@/pages/VenuesPage';
import VenueDetailPage from '@/pages/VenueDetailPage';
import TransportationPage from '@/pages/TransportationPage';
import AccommodationPage from '@/pages/AccommodationPage';
import ContactsPage from '@/pages/ContactsPage';
import MediaPage from '@/pages/MediaPage';
import StatsPage from '@/pages/StatsPage';
import AthleteLoginPage from '@/pages/athlete/AthleteLoginPage';
import AthleteChangePasswordPage from '@/pages/athlete/AthleteChangePasswordPage';
import AthleteDashboardPage from '@/pages/athlete/AthleteDashboardPage';
import AthleteProfilePage from '@/pages/athlete/AthleteProfilePage';
import AthleteEventPage from '@/pages/athlete/AthleteEventPage';
import AthleteCompetitionsPage from '@/pages/athlete/AthleteCompetitionsPage';

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path="announcements" element={<AnnouncementsPage />} />
          <Route path="announcements/:id" element={<AnnouncementDetailPage />} />
          <Route path="competitions" element={<CompetitionsPage />} />
          <Route path="competitions/:id" element={<CompetitionDetailPage />} />
          <Route path="scores" element={<LiveScoresPage />} />
          <Route path="scores/:competitionId" element={<CompetitionScorePage />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="venues" element={<VenuesPage />} />
          <Route path="venues/:id" element={<VenueDetailPage />} />
          <Route path="transportation" element={<TransportationPage />} />
          <Route path="accommodation" element={<AccommodationPage />} />
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="media" element={<MediaPage />} />
          <Route path="stats" element={<StatsPage />} />
        </Route>

        {/* Athlete self-service portal */}
        <Route path="athlete/login" element={<AthleteLoginPage />} />
        <Route path="athlete/change-password" element={<AthleteChangePasswordPage />} />
        <Route path="athlete" element={<ProtectedAthleteRoute><AthleteLayout /></ProtectedAthleteRoute>}>
          <Route index element={<AthleteDashboardPage />} />
          <Route path="dashboard" element={<AthleteDashboardPage />} />
          <Route path="profile" element={<AthleteProfilePage />} />
          <Route path="event" element={<AthleteEventPage />} />
          <Route path="competitions" element={<AthleteCompetitionsPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
